import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'sa-ui';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './simulatedQuestionsMessages';


const ApproveQuestionResultModal = props => {
    const messageMessage =  !props.error ? messages.approvedMessage : messages.error_generic;
    const closeButton =  {
      label: <FormattedMessage {...messages.close} />,
      onClick: props.onClose,
    };
    const continueButton = {
      label: <FormattedMessage {...messages.continue} />,
      onClick: props.onClose,
      primary: true
    }
    const buttons = !props.error ? [closeButton, continueButton] : [closeButton];
    const icon = !props.error ? 'ti-thumbs-up' : 'ti-close';
    return (
       <Modal
        show={props.show}
        onClose={props.onClose}
        icon={icon}
        title={<FormattedMessage {...messages.approved} />}
        buttons={buttons}
      >
        <div class="mt-3">
          <FormattedMessage {...messageMessage} values={props.question}/>
        </div>
      </Modal>
    )
};

ApproveQuestionResultModal.propTypes = {
    
};

export default ApproveQuestionResultModal;